import styled from 'styled-components'

export const RenderItemWrapper = styled('div').attrs(() => ({}))`
  position: absolute;
  left: 0;
  width: 100%;
`

RenderItemWrapper.displayName = 'RenderItemWrapper'
